import { useFind } from 'api/APIHooks';

export const useEditReasonOptions = (feeScheduleId, enabled = false) => {
  const { data: editReasons } = useFind(
    'service_authorization_edit_reasons',
    {
      fee_schedule: feeScheduleId,
    },
    {
      queryConfig: {
        placeholderData: undefined,
        enabled: !!feeScheduleId && enabled,
      },
    },
  );

  return editReasons?.data?.data?.map((editReason) => ({
    label: editReason?.reason,
    value: editReason?.id,
  })) || [];
};
